// extracted by mini-css-extract-plugin
module.exports = {"w1o3yz26":"w1o3yz26","bl5hz2w":"bl5hz2w"};